<template>
  <div>
    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>
<!--      <div class="row" style="width:800px">-->
<!--        <div class="col-3" v-if="currentFilterGroup1 !==''">-->
<!--          <a role="button" class="btn btn-info abutton" @click="FilterByGroup2()">全部</a>-->
<!--        </div>-->
<!--        <div class="col-3" v-for="(item,index) in this.GetUniqueGroup2(currentFilterGroup1)" :key="index" >-->
<!--          <a role="button" class="btn btn-info abutton" @click="FilterByGroup2(item)">{{item}}</a>-->
<!--        </div>-->
<!--      </div>-->

    <hr>

    <a class="btn btn-primary" @click="DataItemMaster_AddLast"><i class="fas fa-plus-circle"></i></a>
    <table class="table table-hover" id="tblMain" style="width:5000px">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
<!--        <th>Tag</th>-->
        <th>縣市</th>
        <th>醫院名稱</th>
        <th>醫院簡稱</th>
        <th>醫院分級</th>
        <th>醫師</th>
        <th>科別</th>
        <th>醫院電話</th>
        <th>醫院地址</th>
        <th>網路掛號連結</th>
        <th>U/A</th>
        <th>抽血檢查BUN creatinine</th>
        <th>腎臟超音波</th>
        <th>膀胱超音波</th>
        <th>膀胱鏡檢查</th>
        <th>尿路動力學檢查</th>
        <th>錄影尿路動力學檢查</th>
        <th>膀胱造瘻</th>
        <th>逼尿肌肉毒桿菌素注射</th>
        <th>尿道括約肌肉毒桿菌素注射</th>
        <th>經尿道膀胱頸切開術</th>
        <th>尿道下吊帶手術</th>
        <th>尿道外括約肌切開手術</th>
        <th>人工括約肌植入手術</th>
        <th>膀胱擴大整形手術</th>
        <th>膀胱自行擴大整形手術</th>
        <th>Ureteral reimplantation</th>
        <th>迴腸通道尿改流</th>
        <th>可禁尿式膀胱造瘻</th>
        <th>可禁尿式尿改流</th>
        <th>膀胱全切除手術</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="(item,index) in datas.Doctors" :key="index">
          <td class="text-center" width="280px">
            <a class="btn btn-primary" @click="DataItemMaster_Insert(item)"><i class="fas fa-plus-circle"></i></a>
            <a class="btn btn-danger" @click="DataItemMaster_Remove(item)"><i class="far fa-trash-alt"></i></a>
            <a class="btn btn-primary" @click="DataItemMaster_MoveUp(item)"><i class="fa fa-angle-up"></i> </a>
            <a class="btn btn-primary" @click="DataItemMaster_MoveDown(item)"><i class="fa fa-angle-down"></i> </a>
          </td>

          <td><input type="text" class="form-control" placeholder="" v-model="item.city"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.hname"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.hnames"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.hlevel"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.name"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.dep"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.tel"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.add"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.link1"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.Uauc"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.bun"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.check1"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.check2"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.check3"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.check4"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.check5"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.opt1"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.opt2"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.opt3"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.opt4"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.opt5"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.opt6"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.opt7"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.opt8"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.opt9"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.opt10"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.opt11"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.opt12"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.opt13"></td>
          <td><input type="text" class="form-control" placeholder="" v-model="item.opt14"></td>

        </tr>
      </tbody>
    </table>

<!--    <DLGEditor ref="dlgEditor" v-on:returnOk="dlgEditorReturnOK" />-->
  </div>
</template>

<script>
/**

 **/

import arrayUtil from "../../util/arrayUtil";
import util from "../../util/util";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";

export default {
  //name: "contentEdit",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{
        Doctors: []
      },
    };
  },
  methods: {
    loadData() {
      let that=this;
      let loader=util.ShowLoading(this);
      apiAdmin.api_getContent(this.$u.TzsciQueryType_Doctor).then((data)=>{
        let dataApi=apiAdmin.init(data.data.data);

        that.datas=dataApi;
        util.HideLoading(loader);
        // that.$nextTick(() => { //with this we skip the first change
        //   that.isLoaded = true
        // })
      })
    },
    submit(){
      apiAdmin.api_saveContent(this.$u.TzsciQueryType_Doctor,this.datas).then(()=>{
        alert('儲存成功')
      })
    },

    DataItemMaster_MoveUp(item) {
      arrayUtil.orderMove(false, item.SystemId, this.datas.Doctors, "SystemId", "OrderKey")
    },
    DataItemMaster_MoveDown(item) {
      arrayUtil.orderMove(true, item.SystemId, this.datas.Doctors, "SystemId", "OrderKey")
    },
    DataItemMaster_AddLast() {
      let newItem = {
        SystemId: "",
        OrderKey: "",
        IsEnable:true,
        Group1: "",
        Tags:[],
        Text: "",
        HtmlContent:"",
      };
      newItem.SystemId = util.uuid();

      arrayUtil.orderAppendLast(newItem, this.datas.Doctors, "OrderKey")
    },
    DataItemMaster_Insert(currentItem){
      let newItem =          {
            SystemId: "",
            OrderKey: "",
            IsEnable:true,
            Group1: "",
            Tags:[],
            Text: "",
            HtmlContent:"",
          };
      newItem.SystemId = util.uuid();

      arrayUtil.orderInsert(newItem,currentItem,this.datas.Doctors,"SystemId","OrderKey")
    },
    DataItemMaster_Remove(item) {
      arrayUtil.removeByPredicate(this.datas.Doctors,s => s.SystemId===item.SystemId);
    },

    // editHtmlContent(item){
    //   this.$refs.dlgEditor.callbackItem=item;
    //   this.$refs.dlgEditor.htmlContent=item.HtmlContent;
    //   this.$refs.dlgEditor.showModal();
    // },
    // dlgEditorReturnOK(item){
    //   item.HtmlContent=this.$refs.dlgEditor.htmlContent;
    // }
  },
  mounted() {
    this.loadData()
  },
}
</script>


<style scoped>
#tblMain{
  width: 1300px;
}
.thisBtnEdit{
  color: white !important;
  margin: 5px;
  width: 40px;
}
.filterItembutton{
  color: white !important;
  width: 220px;
}
.abutton{
  color: white !important;
}
.btn{
  color: white !important;
  margin: 5px;
}
</style>
